<template>
  <div class="recomm">
    <!-- 头部 -->
    <div class="recomm-header">
      <span class="recomm-header__title">为你优选</span>
    </div>

    <YorkbbsSkeleton class="recom-skeleton" :count="7" :loading="optimized.loading" v-if="optimized.loading">
      <div slot="template" class="recom-skeleton__item">
        <el-skeleton-item variant="image"></el-skeleton-item>
      </div>
    </YorkbbsSkeleton>

    <!-- 轮播图 -->
    <swiper :options="swiperOptions" v-show="!optimized.loading">
      <swiper-slide v-for="(item, i) in optimized.list" :key="i">
        <a
          class="recomm-item"
          target="_blank"
          :href="item.operType == 1 ? item.url : `/detail/${item.property.topics[0].englishName}/${item.id}`"
        >
        
          <YorkbbsImage width="100%" height="95px" :src="item.property.logo | webpFormat(150)" v-if="item.property.logo"></YorkbbsImage>
          <YorkbbsImage width="100%" height="95px" :src="item.property.coverImage | webpFormat(150)" v-else></YorkbbsImage>
          
          <div class="recomm-desc">
            <div class="recomm-title e-2">{{ item.title }}</div>
            <div class="recomm-topic">
              {{ item.operType == 1 ? item.property.extend1 : item.property.topics[0].name }}
            </div>
          </div>
        </a>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import {getRandomItems} from '@/utils/utils.js'
import YorkbbsSkeleton from '@/common/skeleton.vue';
export default {
  name: 'Recom',
  components: { YorkbbsSkeleton },
  data() {
    return {
      swiperOptions: {
        // autoplay: true,
        slidesPerView: 7,
        slidesPerGroup: 7,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 5000,
        },
      },
      // 优选信息
      optimized: {
        list: [],
        loading: false,
      },
    };
  },
  created() {
    this.getOptimizedPostList();
  },
  methods: {
    // 获取优选信息
    async getOptimizedPostList() {
      this.optimized.loading = true;
      const { data } = await this.$axios
        .post('/info/v1/get/mainpage/hot/post', {
          offset: 1,
          size: 21,
        })
        .finally(() => {
          this.optimized.loading = false;
        });
      let topArr = [];
      let randomArr = [];
      for(var i=0; i<data.items.length; i++){
        let oncePie = data.items[i];
        if( oncePie.operType == 1 ){
          topArr.push(oncePie)
        }else{
          randomArr.push(oncePie);
        }
      }
      topArr = getRandomItems(topArr,topArr.length); 
      randomArr = getRandomItems(randomArr,21-topArr.length);
      this.optimized.list = [...topArr,...randomArr];
    },
  },
};
</script>
<style lang="scss" scoped>
.recomm {
  padding-top: 30px;
}
.recomm-header {
  line-height: 28px;
  i {
    font-size: 16px;
    color: var(--primary-color);
    margin-left: 4px;
  }
}
.recomm-header__title {
  font-size: 20px;
  font-weight: 500;
}
.recomm-header__tip {
  font-size: 14px;
  color: var(--primary-color);
  margin-left: 20px;
}

.recomm-header__tooltip {
  width: 250px;
  font-size: 14px;
  line-height: 25px;
}

.recomm-item {
  display: block;
  box-sizing: border-box;
  width: 150px;
  height: 182px;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: hidden;
  &:hover {
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  }
}

.recomm-desc {
  padding: 10px;
  font-size: 14px;
  line-height: 20px;
}

.recomm-title {
  font-size: 14px;
  margin-bottom: 5px;
  &:hover {
    color: var(--primary-color);
  }
}

.recomm-topic {
  color: var(--text-color-9);
}

.recomm {
  ::v-deep {
    .swiper-container {
      padding-top: 46px;
      margin-top: -30px;
      padding-bottom: 20px;
    }
    .swiper-pagination-bullet-active {
      width: 20px;
      border-radius: 4px;
      background-color: var(--primary-color);
    }
    .swiper-container-horizontal {
      & > .swiper-pagination-bullets {
        width: auto;
        left: auto;
        bottom: auto;
        right: 0;
        top: 10px;
      }
    }
  }
}

.recom-skeleton {
  padding-bottom: 20px;
  margin-top: 18px;
  position: relative;
  z-index: 1;
  ::v-deep {
    .el-skeleton {
      display: flex;
      justify-content: space-between;
    }
    .recom-skeleton__item {
      width: 150px;
      height: 182px;
    }
    .el-skeleton__image {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
